import { request } from './helpers/request'
import { GENERIC_PASSWORD_CHANGE_CODE } from '../constants/error.codes'

export const submitChangePassword = (data) =>
  request({
    url: `/users/settings/password`,
    headers: {
      'Content-Type': 'application/json',
    },
    data: JSON.stringify(data),
  }).then((response) => {
    if (response.status === 204) {
      return Promise.resolve(response)
    } else if (response.status === 400) {
      return Promise.reject(new Error(response.data.code))
    }
    return Promise.reject(new Error(GENERIC_PASSWORD_CHANGE_CODE))
  })
